import { apiClient } from "@/lib/api/client";

const BASE = "/api/orders/itemgroup/";

export async function getItemGroupComments(id: number) {
  const { data } = await apiClient.get(`${BASE}${id}/comments/`);
  return data;
}

export async function addItemGroupComment(id: number, text: string) {
  const { data } = await apiClient.post(`${BASE}${id}/comments/`, { text });
  return data;
}

export async function loadGroupPremiums(id: number) {
  const { data } = await apiClient.get(`${BASE}${id}/premiums/`);
  return data;
}

export async function changeGroupPremium(id: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.patch(`${BASE}${id}/update_premium/`, payload);
  return data;
}

export async function addItemToGroup(groupId: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.post(`${BASE}${groupId}/add_item/`, payload);
  return data;
}

export async function deleteItemGroup(id: number) {
  const { data } = await apiClient.delete(`${BASE}${id}/`);
  return data;
}

export async function updateItemGroupName(id: number, name: string) {
  const { data } = await apiClient.patch(`${BASE}${id}/`, { name });
  return data;
}

export async function duplicateItemGroup(id: number) {
  const { data } = await apiClient.post(`${BASE}${id}/duplicate/`);
  return data;
}

export async function updateGroupCustomNote(id: number, payload: Record<string, unknown>) {
  const { data } = await apiClient.patch(`${BASE}${id}/custom_note/`, payload);
  return data;
}

export async function setConstructionMethod(groupId: number, methodId: number) {
  const { data } = await apiClient.post(`${BASE}${groupId}/set_construction_method/`, { construction_method: methodId });
  return data;
}

export async function reorderGroupItems(groupId: number, orderedIds: number[]) {
  const { data } = await apiClient.post(`${BASE}${groupId}/reorder_items/`, { ordered_ids: orderedIds });
  return data;
}
